var jQuery = require('jquery');
require('jquery.easing');

window.jQuery = jQuery;
window.$ = jQuery;

var TypeIt = require('typeit').default;
require('moment');
// require('bootstrap');

// require('bootstrap/js/dist/alert');
// require('bootstrap/js/dist/button');
// require('bootstrap/js/dist/carousel');
// require('bootstrap/js/dist/util');
require('bootstrap/js/dist/collapse');
require('bootstrap/js/dist/dropdown');
require('bootstrap/js/dist/modal');
// require('bootstrap/js/dist/popover');
// require('bootstrap/js/dist/scrollspy');
require('bootstrap/js/dist/tab');
// require('bootstrap/js/dist/tooltip');

require('bootstrap-select');
// require('pc-bootstrap4-datetimepicker');
// require('bootstrap-datepicker');
// require('bootstrap-material-design');

require('jquery.placeholder');
// require('jquery-sticky');
// require('jquery-match-height');

require('owl.carousel');
require('magnific-popup');


// DOM Ready functions using custom async function so it only funs when jQuery has been fully loaded

$(function () {


     $("h1,h2,h3,h4,h5,p,span,.dropdown-item ").each(function(){
            $(this).html($(this).html().replace(/&reg;/gi, '<sup>&reg;</sup>').replace(/®/gi, '<sup>&reg;</sup>').replace('<sup><sup>', '<sup>').replace('</sup></sup>', '</sup>'));
        });

    var runAtTime = function (handler, time) {
        var wrapped = function (e) {
            if (e.target.currentTime >= time) {
                $(this).off('timeupdate', wrapped);
                return handler.apply(this, arguments);
            }
        }
        return wrapped;
    };

    function myHandler() {
        $("#para1").fadeIn(300).delay(5680).fadeOut(300);
    }

    function myHandler2() {
        $("#para2").fadeIn(300).delay(13500).fadeOut(300);

        const instance = new TypeIt('#para2-text', {
                speed: 100,
                waitUntilVisible: true,
            })
            .type('Precision', {
                delay: 1500
            })
            .delete(9)
            .type('Speed', {
                delay: 1500
            })
            .delete(5)
            .type('Accuracy', {
                delay: 1500
            })
            .delete(8)
            .type('Efficiency', {
                delay: 1500
            })
            .delete(10)
            .type('Pride', {
                delay: 5500
            })
            .delete(5)

            .go();

        instance.reset();
    }

    // function myHandler3() {
    //     $("#para3").fadeIn(300).delay(2630).fadeOut(300);
    // }

    // function myHandler4() {
    //     $("#para4").fadeIn(300).delay(1650).fadeOut(300);
    // }

    // function myHandler5() {
    //     $("#para5").fadeIn(300).delay(900).fadeOut(300);
    // }

    // function myHandler6() {
    //     $("#para6").fadeIn(300).delay(3670).fadeOut(1500);
    // }


    function myHandler7() {
        $("#para7").fadeIn(300).delay(1500).fadeOut(300);
    }

    function myHandler8() {
        $("#para8").fadeIn(300).delay(1500).fadeOut(300);
    }

    function myHandler9() {
        $("#para9").fadeIn(300).delay(1500).fadeOut(300);
    }

    function myHandler10() {
        $("#para10").fadeIn(300).delay(1500).fadeOut(300);
    }

    function myHandler11() {
        $("#para11").fadeIn(300).delay(1500).fadeOut(1500);
    }

    let subtitleInit = false;

    function initSubtitles() {
        if (subtitleInit) {
            return;
        }

        subtitleInit = true;
        $('#bg-video').on('timeupdate', runAtTime(myHandler, 2.030, 5680, 300));
        $('#bg-video').on('timeupdate', runAtTime(myHandler2, 9.00, 14000, 300));
        // $('#bg-video').on('timeupdate', runAtTime(textRotate, 2.00));
        // $('#bg-video').on('timeupdate', runAtTime(myHandler3, 11.120));
        // $('#bg-video').on('timeupdate', runAtTime(myHandler4, 14.050));
        // $('#bg-video').on('timeupdate', runAtTime(myHandler5, 16.200));
        // $('#bg-video').on('timeupdate', runAtTime(myHandler6, 17.20));

        $('#bg-video').on('timeupdate', runAtTime(myHandler7, 73.00, 1500, 300));
        $('#bg-video').on('timeupdate', runAtTime(myHandler8, 76.00, 1500, 300));
        $('#bg-video').on('timeupdate', runAtTime(myHandler9, 79.00, 1500, 300));
        $('#bg-video').on('timeupdate', runAtTime(myHandler10, 82.00, 1500, 300));
        $('#bg-video').on('timeupdate', runAtTime(myHandler11, 85.00, 1500, 1500));
        $('#bg-video').on('timeupdate', runAtTime(() => {
            subtitleInit = false
        }, 85.50))
    }

    $('#bg-video').on('timeupdate', function (e) {
        if (e.target.currentTime <= 1) {
            initSubtitles();
        }
    });

    if (location.hash.substr(0, 2) == "#!") {
        setTimeout(() => {
            $("a[data-toggle='tab']").removeClass('active');
            $("a[href='#" + location.hash.substr(2) + "']").tab("show");
        }, 500)
    }

    $("a[data-toggle='tab']").on("shown.bs.tab", function (e) {
        var hash = $(e.target).attr("href");
        if (hash.substr(0, 1) == "#") {
            location.replace("#!" + hash.substr(1));
        }
    });

    // let url = location.href.replace(/\/$/, "");

    // if (location.hash) {
    //     const hash = url.split("#");
    //     url = location.href.replace(/\/#/, "#");
    //     history.replaceState(null, null, url);
    //     setTimeout(() => {
    //         $(window).scrollTop(0);
    //     }, 400);
    // }
    // $('a[data-toggle="tab"]').on("click", function() {
    //     let newUrl;
    //     const hash = $(this).attr("href");
    //     if (hash == "#home") {
    //         newUrl = url.split("#")[0];
    //     } else {
    //         newUrl = url.split("#")[0] + hash;
    //     }
    //     // newUrl += "/";
    //     history.replaceState(null, null, newUrl);
    // });


    $('.hide-all').on('click', function(){
        $('.multi-collapse').collapse('hide');
    });
    $('.expand-all').on('click', function(){
        $('.multi-collapse').collapse('show');
    });

    $('#btn-mob-nav, #mob-nav .nav-link').on('click', function () {
        $('#mob-nav').fadeToggle('slow');
        $('#btn-mob-nav .open-menu').toggleClass('d-block');
        $('#btn-mob-nav .close-menu').toggleClass('d-none');
        $(this).toggleClass('active');
        $('.sidebar-offcanvas').toggleClass('active');
    });

    // $('#btn-mob-nav').click(function() {
    //     $(this).toggleClass('close-btn')

    // });


    // Universal Analytics event tracking
    if (typeof ga !== 'undefined') {

        // track all phone number click events
        $('a[href^="tel:"]').on('click', function (e) {
            var href = $(this).attr('href');
            var value = href.split(':');

            // console.log('clicked', $(this).text(), value[1]);
            ga('send', 'event', 'Phone', 'click', value[1]);
        });

        // track all email click events
        $('a[href^="mailto:"]').on('click', function (e) {

            var href = $(this).attr('href');
            var value = href.split(':');

            // console.log('clicked', $(this).text(), value[1]);
            ga('send', 'event', 'Email', 'click', value[1]);
        });

    }

    // Toggle first tab
    if ($('#product-nav > .nav-item').length) {
        $('#product-nav > .nav-item > .nav-link')[0].classList.add('active');
    }

    if ($('#product-tab > .tab-pane').length) {
        $('#product-tab > .tab-pane')[0].classList.add('active');
    }

    // placeholder polyfill for browsers that need it
    $('input, textarea').placeholder();


    // Off canvas mobile nav
    $('[data-toggle="offcanvas"]').click(function () {
        $('.offcanvas').toggleClass('active');
        $(this).toggleClass('close-btn')

    });

    $('select[data-toggle="tabOption"]').on('change', function (e) {
        e.preventDefault();
        let target = e.target.value;
        target = $('#' + target);
        target.addClass('active');
        target.siblings().removeClass('active');
    })

    if ($('.product-models-gallery').length) {
        // the containers for all your galleries
        // $('.gallery-mag-popup').each(function() {
        $('.product-models-gallery').magnificPopup({
            delegate: 'a.model-item', // the selector for gallery item
            type: 'iframe',

            iframe: {
                markup:

                    '<div class="mfp-iframe-scaler">' +
                    '<div class="mfp-close"></div>' +
                    '<div class="mfp-title"></div>' +
                    '<iframe class="mfp-iframe" frameborder="0" allowfullscreen></iframe>' +
                    '<div class="mfp-counter"></div>' +

                    '</div>',
            },

            gallery: {
                enabled: true,
                tCounter: '<span class="mfp-counter">Model %curr% of %total%</span>', // markup of counter
                arrowMarkup: '<button title="%title%" type="button" class="mfp-arrow mfp-arrow-%dir%"><i class="material-icons">arrow_back</i></button>', // markup of an arrow button
            },

            callbacks: {

                buildControls: function () {
                    // re-appends controls inside the main container
                    if (this.arrowLeft) {
                        this.contentContainer.append(this.arrowLeft.add(this.arrowRight));
                    }
                },
                markupParse: function (template, values, item) {
                    values.title = item.el.attr('title');
                }

            }
        });
    }

    if ($('#products-carousel').length) {
        $('#products-carousel').owlCarousel({
            responsiveRefreshRate: 1,
            loop: false,
            margin: 24,
            responsiveClass: true,
            items: 1,
            nav: true,
            navText: [
                '<i class="material-icons" aria-hidden="true">arrow_back</i>',
                '<i class="material-icons" aria-hidden="true">arrow_forward</i>',
            ],
            dots: false,
            dotsEach: 2,
            autoplay: false,
            autoplayTimeout: 1000,
            smartSpeed: 750,
            responsive: {

                768: {
                    items: 2,
                },
                1200: {
                    items: 3,
                    dotsEach: 1,
                },
                1600: {
                    items: 4,
                },
                2545: {
                    items: 5,
                },
            },

        })
    }



    var bigimage = $("#big");
    var thumbs = $("#thumbs");
    //var totalslides = 10;
    var syncedSecondary = true;

    bigimage
        .owlCarousel({
            items: 1,
            nav: false,
            autoplay: false,
            autoplaySpeed: 1000,
            dots: false,
            dotsEach: 2,
            loop: true,
            margin: 0,
            responsiveRefreshRate: 200,
            nav: true,
            navText: [
                '<i class="material-icons" aria-hidden="true">arrow_back</i>',
                '<i class="material-icons" aria-hidden="true">arrow_forward</i>',
            ],
        })
        .on("changed.owl.carousel", syncPosition);

    thumbs
        .on("initialized.owl.carousel", function () {
            thumbs
                .find(".owl-item")
                .eq(0)
                .addClass("current");
        })
        .owlCarousel({
            items: 6,
            dots: false,
            nav: false,
            margin: 8,
            slideBy: 6,
            responsiveRefreshRate: 100
        })
        .on("changed.owl.carousel", syncPosition2);

    function syncPosition(el) {
        //if loop is set to false, then you have to uncomment the next line
        //var current = el.item.index;

        //to disable loop, comment this block
        var count = el.item.count - 1;
        var current = Math.round(el.item.index - el.item.count / 2 - 0.5);

        if (current < 0) {
            current = count;
        }
        if (current > count) {
            current = 0;
        }
        //to this
        thumbs
            .find(".owl-item")
            .removeClass("current")
            .eq(current)
            .addClass("current");
        var onscreen = thumbs.find(".owl-item.active").length - 1;
        var start = thumbs
            .find(".owl-item.active")
            .first()
            .index();
        var end = thumbs
            .find(".owl-item.active")
            .last()
            .index();

        if (current > end) {
            thumbs.data("owl.carousel").to(current, 100, true);
        }
        if (current < start) {
            thumbs.data("owl.carousel").to(current - onscreen, 100, true);
        }
    }

    function syncPosition2(el) {
        if (syncedSecondary) {
            var number = el.item.index;
            bigimage.data("owl.carousel").to(number, 100, true);
        }
    }

    thumbs.on("click", ".owl-item", function (e) {
        e.preventDefault();
        var number = $(this).index();
        bigimage.data("owl.carousel").to(number, 300, true);
    });

    if ($('.down-scroll').length) {
        // Page scroll
        $('.down-scroll').bind('click', function (event) {
            var $anchor = $(this);

            $('html, body').stop().animate({
                scrollTop: $($anchor.attr('href')).offset().top - 72
            }, 500, 'easeInOutExpo');

            event.preventDefault();
        });
    }



    scrollToFormError();

    $(window).scroll(function () {
        if ($(this).scrollTop() > 125) {
            $('.navbar--main').addClass('page-down');
            $('#home-header .navbar-dark').removeClass('nav-down');
            $('#home-header .navbar-dark').addClass('nav-up');


            $('#home-header .navbar-light').addClass('nav-down');
            $('#home-header .navbar-light').removeClass('nav-up');


        } else {
            $('.navbar--main').removeClass('page-down');

            $('#home-header .navbar-dark').addClass('nav-down');
            $('#home-header .navbar-dark').removeClass('nav-up');

            $('#home-header .navbar-light').removeClass('nav-down');
            $('#home-header .navbar-light').addClass('nav-up');

        }
    });

    var hash = window.location.hash;
    var has3d = hash.match(/^\#\@(\w+)/)
    if (has3d) {
        $(`#${has3d[1]}`).click();
    }
});

// scroll window to form error element and offset fixed header height
function scrollToFormError() {
    // console.log('scrollToFormError', window.location.hash);
    var windowWidth = $(window).width();
    var formStr = '#form-';
    // enquiry form error anchor offset
    if (window.location.hash && window.location.hash.indexOf(formStr) != -1) {

        var formEl = window.location.hash;
        if ($(formEl).length > 0) {

            // var offsetSize = $('.headerfixed').height();
            // console.log(window.location.hash+' '+offsetSize +' '+$(formEl).scrollTop());
            setTimeout(() => {
                var offsetSize = $('.navbar--main').height() + 300;
                if (windowWidth > 767) {
                    // offset
                    // animate scrollto
                    $('html, body').animate({
                        scrollTop: $(formEl).offset().top - offsetSize
                    }, 1000);
                } else {
                    $('html, body').animate({
                        scrollTop: $(formEl).offset().top - offsetSize
                    }, 1000);
                }
            }, 500)

        }
    }
}

//-----------------------------------------------
// Global AJAX / Application Functions
//-----------------------------------------------
function initAjaxJS() {

    // Infinite Ajax Scroll
}


// WEBPACK FOOTER //
// ./resources/assets/site/js/init.js